/* eslint-disable import/prefer-default-export */
const isMaxeon = (invoiceConfig: any) =>
  !!invoiceConfig?.integration_config?.length &&
  !!invoiceConfig.integration_config.find((item: any) => item.company_name === "maxeon-solar-technologies");

export const modifyDraftData = (data: any, invoiceConfig: any) => {
  if (!data) return;
  if (isMaxeon(invoiceConfig)) {
    const maxeonData = invoiceConfig.integration_config.find(
      (item: any) => item.company_name === "maxeon-solar-technologies",
    );
    if (!data?.invoice) {
      data.invoice = {};
    }
    if (invoiceConfig?.provider_invoice_ref_03 !== 0 && !data?.invoice?.provider_invoice_reference_03) {
      data.invoice.provider_invoice_reference_03 = maxeonData?.currencies?.[0];
    }
    if (invoiceConfig?.provider_invoice_ref_01 !== 0 && !data?.invoice?.provider_invoice_reference_01) {
      data.invoice.provider_invoice_reference_01 = maxeonData?.lsp_entities?.[0];
    }
  }
  /**
   * Remove any parent items from the goods list
   * The backend returns both the updated and the original parent item
   * We only want to keep the updated item to display in the form
   */
  data.goods = data.goods.filter((item: any) => {
    const isParentItem = data.goods.find((good: any) => good.parent_id === item.id);
    if (isParentItem) {
      return false;
    }
    return true;
  });

  // For some reason the backend returns the additional_field data in other_instructions
  data.goods = data?.goods?.map((good: any) => {
    if (good.other_instructions) {
      // Remove other_instructions key
      const { other_instructions, ...goodWithoutOtherInstructions } = good;
      return {
        ...goodWithoutOtherInstructions,
        additional_field: other_instructions,
      };
    }
    return good;
  });
  return data;
};

export const parseDraftValues = (data: any) => {
  // deep cloning so orignal RHF state don't get mutated.
  const clonedData = JSON.parse(JSON.stringify(data));

  // in case of custom cities city_id is string no need to pass as city filed will be used instead
  if (
    clonedData?.invoice?.billed_from?.city_id &&
    typeof clonedData.invoice.billed_from.city_id === "string" &&
    clonedData.invoice.billed_from.city
  ) {
    clonedData.invoice.billed_from.city_id = null;
  }

  if (
    clonedData?.invoice?.billed_to?.city_id &&
    typeof clonedData.invoice.billed_to.city_id === "string" &&
    clonedData.invoice.billed_to.city
  ) {
    clonedData.invoice.billed_to.city_id = null;
  }

  // modify data if needed before sending as a draft
  return clonedData;
};
